import { render, staticRenderFns } from "./CarIntroduction.vue?vue&type=template&id=0cd40b3c&scoped=true"
import script from "./CarIntroduction.vue?vue&type=script&lang=js"
export * from "./CarIntroduction.vue?vue&type=script&lang=js"
import style0 from "./CarIntroduction.vue?vue&type=style&index=0&id=0cd40b3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd40b3c",
  null
  
)

export default component.exports